import { useMemo } from "react";
import type { CoachingClip } from "@/lib/types";
import { loadDrawing } from "@/lib/canvas/telestrator-schema";
import { FeedbackMediaThumbnail } from "./FeedbackMediaThumbnail";
import { ThumbnailDrawingOverlay } from "./VideoNoteThumbnail";

export type VideoClipThumbnailProps = {
  clip: Pick<CoachingClip, "id" | "drawing">;
  className: string;
  testId: string;
  placeholderTestId: string;
  overlayTestId?: string;
  imgClassName?: string;
};

/** Static first-frame preview for a saved clip.
 *
 * Clip thumbnails come from the clip start frame, and clips can carry
 * a saved telestration snapshot. Paint that drawing over the same
 * thumbnail frame so rail/library previews match the evidence coaches
 * and players review.
 */
export function VideoClipThumbnail({
  clip,
  className,
  testId,
  placeholderTestId,
  overlayTestId = "video-clip-drawing-overlay",
  imgClassName,
}: VideoClipThumbnailProps) {
  const drawingObjects = useMemo(
    () => loadDrawing(clip.drawing).objects,
    [clip.drawing],
  );
  return (
    <FeedbackMediaThumbnail
      kind="clip"
      id={clip.id}
      testId={testId}
      placeholderTestId={placeholderTestId}
      className={className}
      imgClassName={imgClassName}
    >
      {drawingObjects.length > 0 ? (
        <ThumbnailDrawingOverlay
          overlayId={`clip-${clip.id}`}
          objects={drawingObjects}
          testId={overlayTestId}
        />
      ) : null}
    </FeedbackMediaThumbnail>
  );
}
